import { useCustomTranslation } from '../../../../hooks';
import { GanttQueue, QueueBatchNode } from '../Gantt/types';
import { useFormatTaskDuration, useProductionTaskLocate } from '../Gantt/hooks';
import { Badge } from '@nexelem/components';
import { CUSTOM_ICONS } from '@nexelem/icons';
import { TaskMainValueOptions, useProductionPlanSettings } from '../components/SettingsDrawer';
import { ProductionOrderNumber } from '../Gantt/components';

type NodeBatchSearchResultProps = {
  node: QueueBatchNode;
  queue: GanttQueue;
};
export const SingleNodeBatchSearchResult = ({ node, queue }: NodeBatchSearchResultProps) => {
  const { t, tWrapper } = useCustomTranslation('products.productionPlan');
  const formatTaskDuration = useFormatTaskDuration();
  const showProductName = useProductionPlanSettings((state) => state.taskMainValue === TaskMainValueOptions.PRODUCT);
  const locate = useProductionTaskLocate();

  const searchId = node.tasks?.[0]?.id;

  return (
    <div
      className="flex cursor-pointer items-center justify-between border-border-secondary px-6 py-2 not-last:border-b hover:bg-surface-focus-lighter"
      onClick={() =>
        searchId &&
        locate({ taskId: searchId, queueId: queue.id, taskStartDate: node.startDate, markAsSearchSelected: true })
      }
    >
      <div className="flex w-full flex-col gap-1.5">
        <Badge className="w-fit" StartIcon={<CUSTOM_ICONS.Merge className="text-icon-darker" />}>
          {`${tWrapper('batch')} ${node.name}`}
        </Badge>
        {node.tasks?.map(({ productName, name, id, productionOrderDetails, progress }) => (
          <div className="flex flex-col text-s16-sb" key={id}>
            <div className="flex justify-between gap-2">
              <span>{showProductName ? productName : name}</span>
              <span className="text-s16 text-nowrap">
                {progress.totalAmount.amount} {progress.totalAmount.unit.name}
              </span>
            </div>
            <div className="flex gap-2">
              <ProductionOrderNumber
                productionOrderExternalNumber={productionOrderDetails?.externalId}
                productionOrderNumber={productionOrderDetails?.number}
              />
            </div>
          </div>
        ))}
        <div className="mt-1 text-s11-sb text-text-secondary uppercase">
          <span>{formatTaskDuration(node)}</span>
          <div className="flex gap-x-4">
            <span>{queue.shortName}</span>
            <span>{t('workStation.list.area', { areaName: queue.area.name })}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
